import { Fragment } from "react";
import img1 from "../img/products/1-xs-min.png"
import img2 from "../img/products/2-xs-min.png"
import img3 from "../img/products/3-xs-min.png"
import img4 from "../img/products/4-xs-min.png"
import img5 from "../img/products/5-xs-min.png"
import img6 from "../img/products/6-xs-min.png"

const productsItems = {
    headTitle: {
        en: <Fragment>Hundreds of shapes, even more flavours <br className="hidden-xs" /> There are thousands of flavours in the world. Everyone has the chance to discover their favourite!</Fragment>,
        ka: <Fragment>ასობით ფორმა და კიდევ უფრო მეტი გემო <br className="hidden-xs" /> მსოფლიოში ათასობით განსხვავებული გემოა და ყველას აქვს შანსი, იპოვოს თავისი საყვარელი არომატი!</Fragment>,
    },
    headSubTitle: {
        en: "We believe everyone deserves to discover sweets they’ll want to devour. This is why we choose the very best ingredients and the most reliable suppliers. Take a peek inside our barrels!",
        ka: "გვჯერა, რომ ყველას უნდა ჰქონდეს შესაძლებლობა აღმოაჩინოს ტკბილეული, რომელზეც უარს ვერ ამბობს. ამიტომ ვირჩევთ მხოლოდ საუკეთესო ინგრედიენტებს და სანდო მომწოდებლებს. აღმოაჩინე რა იმალება ჩვენს კასრებში!",
    },
    stores: {
        en: "Our stores",
        ka: "ჩვენი მაღაზიები",
    },
    en: [
        {
            title: "Tangy jelly",
            description: "Not every pirate will admit to having a sweet tooth. This seriously tangy jelly is different!  Treat yourself to your favourite sweet while holding onto your hard-core image with its rock hard outside and sweet soft centre.",
            img: img1,
        },
        {
            title: "Sweet jelly",
            description: "Banana, strawberry, bear or a dual-coloured skull, take your pick. This is the king among sweets. On a number of islands we visited, the wealth of the future bride is judged by the size of her jelly dowry!",
            img: img2,
        },
        {
            title: "Batons",
            description: "The baton forms an integral part of all pirate expeditions. Not only does it taste great and have fantastic lasting power, but if necessary it can also double up as a sailing rope and can come in handy for tying up hostages.",
            img: img3,
        },
        {
            title:<Fragment>Marsh-<br />mallow</Fragment>,
            description: "If only our ship was made out of marshmallow! It would either reflect or soak up any cannon balls thrown at us by our enemy. We’ve already tried to build a small sloop out of it, however most of the material mysteriously evaporated… ",
            img: img4,
        },
        {
            title: "Chocolate",
            description: "While every proper pirate is tough on the outside, but soft on the inside, you’ll find the exact opposite with these chocolate sweets. Beneath the softest chocolate shell we find crunchy almonds, hazelnuts, chunks of coconut and much more!",
            img: img5,
        },
        {
            title: "Chewing gum",
            description: "When not chewing coca leaves, pirates can be found chewing gum. But not the typical white variety. Even the lowest ranking sailor turns his nose up at that. Pirate chewing gum is colourful and tastes different every time!",
            img: img6,
        },
    ],
    ka: [
        {
            title: "მჟავე ჟელე",
            description: "ყველა მეკობრე არ აღიარებს, რომ ტკბილეულის მოყვარულია. ეს მჟავე ჟელე კი გამონაკლისია! გაანებივრე თავი საყვარელი ტკბილეულით და თან შეინარჩუნე შენი “კერკეტი” იმიჯი - ხრაშუნა გარსითა და რბილი, ტკბილი შიგთავსით.",
            img: img1,
        },
        {
            title: "ტკბილი ჟელე",
            description: "ბანანი, მარწყვი, დათვი თუ ორფერიანი თავის ქალა — აირჩიე რაც გინდა. ტკბილი ჟელიბონი ტკბილეულებს შორის ნამდვილი ფავორიტია! ზოგიერთ კუნძულზე კი, სადაც ჩვენ ვიყავით, მომავალ პატარძალს ჟელეს მზითევის ზომით აფასებენ.",
            img: img2,
        },
        {
            title: "ჩხირები",
            description: "ჩხირები ყველა მეკობრის ექსპედიციის აუცილებელი ნაწილია. ისინი საოცრად გემრიელია და დიდხანს ინარჩუნებს არომატს, ხოლო საჭიროების შემთხვევაში იალქნის თოკადაც გამოდგება — ან „მძევლების დასაბმელადაც კი“",
            img: img3,
        },
        {
            title:<Fragment>მარშმე-<br />ლოუ</Fragment>,
            description: "ნეტავ ჩვენი გემი მარშმელოუსი ყოფილიყო! მტრის ნასროლ ქვემეხის ბირთვებს ან უკანვე გააბრუნებდა, ან სულაც შთანთქავდა. პატარა ნავიც კი ავაშენეთ მისგან, მაგრამ მასალის დიდი ნაწილი იდუმალად აორთქლდა…",
            img: img4,
        },
        {
            title: "შოკოლადი",
            description: "მაშინ როცა ნამდვილი მეკობრე გარეგნულად მკაცრია, შინაგანად კი თბილი, ამ შოკოლადის ტკბილეულში ყველაფერი პირიქითაა. უნაზესი შოკოლადის გარსის ქვეშ იმალება ხრაშუნა ნუში, თხილი, ქოქოსის ნატეხები და კიდევ ბევრი სხვა არომატი.",
            img: img5,
        },
        {
            title: "საღეჭი რეზინი",
            description: "მეკობრეებს საღეჭი რეზინის გარეშე იშვიათად შეხვდები. ოღონდ არა ჩვეულებრივი თეთრი საღეჭის — მასზე ყველაზე გამოუცდელი მეზღვაურიც კი ცხვირს იბზუებს. ნამდვილი მეკობრის საღეჭი რეზინი ფერადია და ყოველ ჯერზე განსხვავებული გემო აქვს!",
            img: img6,
        },
    ],
}

export { productsItems };